import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
// import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { ReportSidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { selectUserPermissions } from "core/redux/slice/userPermissionSlice";
import { hasPermission } from "core/Operations/checkPermission";
import { it } from "date-fns/locale";

const ReportSidebar = () => {
  // const SidebarData = useSelector((state) => state.sidebar_data);
  // console.log(SidebarData, "sidebar");
  const userData = useSelector(loggedInUser);
  // const allowedMenus = userData?.access?.map((access) => access.menuName);
  // const permissions =
  //   useSelector(selectUserPermissions) || userData?.permissions;
  const permissions = userData?.permissions;
  const Location = useLocation();

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    if (title == subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {ReportSidebarData?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>

                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        // let link_array = [];

                        const link_array = title?.submenuItems?.flatMap(
                          (link) => {
                            const items = [link.link];

                            if (link.submenu) {
                              items.push(
                                ...link.submenuItems.map((item) => item.link)
                              );
                            }
                            return items;
                          }
                        );

                        title.links = link_array;

                        return (
                          hasPermission(
                            permissions,
                            title?.accessCode,
                            "",
                            "haveView"
                          ) && (
                            <li className="submenu" key={i}>
                              <Link
                                to={title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                // className={`${
                                //   subOpen == title?.label ? "subdrop" : ""
                                // } ${
                                //   title?.links?.includes(Location.pathname)
                                //     ? "active"
                                //     : ""
                                // }`}
                                className={`${
                                  subOpen === title?.label ? "subdrop" : ""
                                } ${
                                  title?.submenu
                                    ? title?.links?.includes(Location.pathname)
                                      ? "active"
                                      : ""
                                    : title?.link === Location.pathname
                                    ? "active"
                                    : ""
                                }`}
                              >
                                {title?.icon}
                                <span>{title?.label}</span>
                                <span
                                  className={title?.submenu ? "menu-arrow" : ""}
                                />
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen == title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => {
                                    const permissionsCheck = hasPermission(
                                      permissions,
                                      "Report",
                                      "",
                                      "haveView"
                                    );
                                    return (
                                      permissionsCheck && (
                                        <li
                                          className="submenu submenu-two"
                                          key={titleIndex}
                                        >
                                          <Link
                                            to={item?.link}
                                            className={
                                              item?.submenuItems
                                                ?.map((link) => link?.link)
                                                .includes(Location.pathname) ||
                                              item?.link == Location.pathname
                                                ? "active"
                                                : ""
                                            }
                                            onClick={() => {
                                              toggleSubsidebar(item?.label);
                                            }}
                                          >
                                            {item?.label}
                                            <span
                                              className={
                                                item?.submenu
                                                  ? "menu-arrow"
                                                  : ""
                                              }
                                            />
                                          </Link>
                                          <ul
                                            style={{
                                              display:
                                                subsidebar == item?.label
                                                  ? "block"
                                                  : "none",
                                            }}
                                          >
                                            {item?.submenuItems?.map(
                                              (items, titleIndex) => {
                                                const permissionsCheck2 =
                                                  hasPermission(
                                                    permissions,
                                                    "Report",
                                                    items?.accessCode,
                                                    "haveView"
                                                  );

                                                return (
                                                  permissionsCheck2 && (
                                                    <li key={titleIndex}>
                                                      <Link
                                                        to={items?.link}
                                                        className={`${
                                                          subsidebar ==
                                                          items?.label
                                                            ? "submenu-two subdrop"
                                                            : "submenu-two"
                                                        } ${
                                                          items?.submenuItems
                                                            ?.map(
                                                              (link) =>
                                                                link.link
                                                            )
                                                            .includes(
                                                              Location.pathname
                                                            ) ||
                                                          items?.link ==
                                                            Location.pathname
                                                            ? "active"
                                                            : ""
                                                        }`}
                                                      >
                                                        {items?.label}
                                                      </Link>
                                                    </li>
                                                  )
                                                );
                                              }
                                            )}
                                          </ul>
                                        </li>
                                      )
                                    );
                                  }
                                )}
                              </ul>
                            </li>
                          )
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default ReportSidebar;
